import { decode as base64_decode, encode as base64_encode } from "base-64";
import RootStore from "./RootStore";
import { postApi, baseURL } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import { message } from "antd";
import config from "../config";

class OverTimeReportStore {
  overTimeReport = [];
  total = 0;
  loading = false;
  rootStore;
  remaning_driverId = "";
  last_record_timestamp = "";
  pythonReportMessage = false;

  constructor(rootStore) {
    makeObservable(this, {
      overTimeReport: observable,
      remaning_driverId: observable,
      last_record_timestamp: observable,
      // total:observable,
      loading: observable,
      loadData: action,
      pythonReportMessage: observable,
    });
    this.rootStore = rootStore;
  }

  async loadData({
    companyId,
    driverId,
    offset,
    limit,
    fromDate,
    toDate,
    pageNo,
  }) {
    this.loading = true;
    var postData = {
      companyId: companyId,
      driverId: driverId,
      fromDate: fromDate,
      toDate: toDate,
      offset: offset,
      limit: limit,
      page: pageNo,
    };

    if (config.pythonReport === 1) {
      // postData.companyId=118
      // postData.driverId=[2142]
      // postData.fromDate="2023-01-01 00:00:00"
      // postData.toDate="2023-01-07 12:54:00"
      if (offset === 0) {
        postData.last_record_timestamp = "";
        postData.remaning_driverId = "";
      } else {
        postData.last_record_timestamp = this.last_record_timestamp;
        postData.remaning_driverId = this.remaning_driverId;
      }

      var response = await postApi
        .getClient("report")
        .post("/driver_report/overtime", postData);
      this.total = parseInt(response?.data?.data?.TotalCount);
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post("index.php?c=driver&a=overTimecharge", "postData=" + base64Input);
      this.total = parseInt(response?.data?.data?.TotalCount);
    }

    if (config.pythonReport === 1) {
      this.last_record_timestamp = response?.data?.data?.last_record_timestamp;
      this.remaning_driverId = response?.data?.data?.remaning_driverId;
    }
    // console.log(response?.data?.data)
    this.overTimeReport = response?.data?.data?.overtimecharge;
    // console.log(this.total)
    this.loading = false;
  }

  async exportExcel(getData) {
    // console.log("getData", getData);

    if (config.pythonReport === 1) {
      getData = { ...getData, language: "english" };
      // getData = { ...getData, companyId: 118 }
      // getData = { ...getData, driverId: [2142],fromDate: "2023-01-01 00:00:00", toDate: "2023-01-07 12:54:00" }
      try {
        await postApi
          .getClient("report")
          .post("/driver_report/overtime/download/excel", getData, {
            responseType: "blob",
          });
        this.pythonReportMessage = true;
        // await message.success("The report will be generated shortly. You can check its status in the pending report list.", 2);
      } catch (error) {
        this.pythonReportMessage = false;
        message.error("Failed to download the report. Please try again.");
      }
    } else {
      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=driver&a=exportovertimeexcel&cid=" +
        getData.companyId +
        "&userId=" +
        getData.userId +
        "&did=" +
        getData.vehicleId +
        // "&int="+
        // getData.interval+
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;
    }
  }

  async exportpdf(getData) {
    if (config.pythonReport === 1) {
      getData = { ...getData, language: "english" };
      // getData = { ...getData, companyId: 118 }
      // getData = { ...getData, driverId: [2142],fromDate: "2023-01-01 00:00:00", toDate: "2023-01-07 12:54:00" }
      try {
        await postApi
          .getClient("report")
          .post("/driver_report/overtime/download/pdf", getData, {
            responseType: "blob",
          });
        this.pythonReportMessage = true;
        // await message.success("The report will be generated shortly. You can check its status in the pending report list.", 2);
      } catch (error) {
        this.pythonReportMessage = false;
        message.error("Failed to download the report. Please try again.");
      }
    } else {
      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=driver&a=exportovertimepdf&cid=" +
        getData.companyId +
        "&userId=" +
        getData.userId +
        "&did=" +
        getData.vehicleId +
        // "&int="+
        // getData.interval+
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;
    }
  }

  async exportcsv(getData) {
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=driver&a=exportovertimecsv&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&did=" +
      getData.vehicleId +
      // "&int="+
      // getData.interval+
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList +
      "&language=" +
      lang;
  }
  async exportxml(getData) {
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=driver&a=exportovertimexml&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&did=" +
      getData.vehicleId +
      // "&int="+
      // getData.interval+
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList +
      "&language=" +
      lang;
  }
}

export default OverTimeReportStore;
